import {compileDictionaryBody} from "./compileDictionaryBody";

export function compileDictionary(
  compiledKeyValuePairs: Record<string, string>
): string {
  return `{
  ${compileDictionaryBody(compiledKeyValuePairs)}
}`;
}
